import RoundedButton from 'components/RoundedButton';
import { ENTER_CTA_LINK } from 'utils/cta/CTA';
import styles from './EnterButton.module.css';

export const EnterButton = () => {
  return (
    <div className={styles.ctaButton}>
      <RoundedButton
        href={ENTER_CTA_LINK}
        rebrandDm2025
        colorStyle="Primary"
        fullWidth
      >
        Enter To Win
      </RoundedButton>
    </div>
  );
};
